<template>
  <div>
    <select
      @change="changeValue"
      v-model="localValue"
      :class="setClasses"
      class="form-select"
      :disabled="disabled"
    >
      <option v-for="option in data" :value="option.value" :key="option.id">{{
        option.name
      }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'base-select',
  inheritAttrs: false,
  props: {
    data: {
      type: Array,
      required: true
    },
    value: {
      type: [Number, String],
      required: true
    },
    size: {
      type: String,
      default: 'none'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      localValue: this.value
    }
  },
  computed: {
    setClasses: function () {
      return {
        'h-8 py-1 text-sm': this.size === 'tiny',
        'h-6 py-0 text-sm': this.size === 'tinyxs',
        'cursor-not-allowed': this.disabled,
      }
    }
  },
  watch: {
    value: function (value) {
      this.localValue = value
    }
  },
  methods: {
    changeValue: function () {
      this.$emit('input', this.localValue)
      this.$emit('change', this.localValue)
    }
  }
}
</script>

<style lang="scss" scoped></style>
